import { useEffect, useState } from 'react';
import { apiRequests } from '../../shared/api/apiRequests';
import { LastReview } from '../../entities/LastReview';
import { LastProduct } from '../../entities/LastProduct/ui/LastProduct';
import { Link } from 'react-router-dom';
import { RightArrow } from '../../shared/icons/RightArrow';

const MainPage = () => {
  const [reviews, setReviews] = useState([]);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const getData = () => {
      apiRequests.reviews.get().then((res) => {
        setReviews(res);
      });
      apiRequests.products.getOrders(2).then((res) => {
        if (res && res.items && Array.isArray(res.items)) {
          setProducts(res);
        } else if (res && res.value && res.value.items) {
          setProducts(res.value);
        } else if (res) {
          const productsArray = Object.values(res);
          setProducts({ items: productsArray, totalCount: productsArray.length });
        }
      });
    };

    getData();
  }, []);

  return (
    <>
      <section className="mb-4">
        <div className="row"></div>
      </section>

      <section className="mb-4">
        <div className="header-section mb-3">
          <h4 className="headline">Последние продажи</h4>
          <Link to="/shop/orders" className="link-to">
            Все продажи
            <RightArrow />
          </Link>
        </div>

        <div className="row">
          {products?.items?.length > 0 ? (
            products?.items.slice(0, 2).map((i) => <LastProduct data={i} key={i.id} />)
          ) : (
            <p className="text-sm-start">Отсутствуют</p>
          )}
        </div>
      </section>

      <section>
        <div className="header-section mb-3">
          <h4 className="headline">Последние отзывы</h4>
          <Link to="/reviews" className="link-to">
            Все отзывы
            <RightArrow />
          </Link>
        </div>

        <div className="row">
          {reviews?.items?.slice(0, 2).map((i) => (
            <LastReview key={i.id} data={i} />
          ))}
        </div>
      </section>
    </>
  );
};

export default MainPage;
